import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var Mail = function Mail(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 20.0001C20.5056 19.9995 22 18.5099 22 16.6712V7.32884C22 5.49021 20.5056 4.00055 18.6667 4H5.33333C3.49444 4.00055 2 5.49021 2 7.32884V16.6712C2 18.5099 3.49444 19.9995 5.33333 20.0001H18.6667ZM14 13L18.6667 18H5.33333L10 13L11.2168 14.2365C11.4224 14.4435 11.7057 14.5617 12.0002 14.5617C12.2946 14.5617 12.578 14.4435 12.7835 14.2365L14 13ZM8.65689 11.6801L4 16.6712V7.32884L8.65689 11.6801ZM20 16.6712V7.32884L15.3435 11.68L20 16.6712ZM18.6667 6H5.33333L12 12.5L18.6667 6Z",
    fill: color
  }));
};

export { Mail };
